var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestReview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8382 2.78085L7.00016 7.9428L7.94296 7L2.78101 1.83803C3.93026 0.897581 5.39932 0.333334 7.00016 0.333334C10.682 0.333334 13.6668 3.3181 13.6668 7C13.6668 10.6819 10.682 13.6667 7.00016 13.6667C3.31826 13.6667 0.333496 10.6819 0.333496 7C0.333496 5.39915 0.897743 3.93009 1.8382 2.78085Z",
    fill: "#4F8CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestReview);
export default __webpack_public_path__ + "static/media/request-review.d3efd334793e8cebaef66296abbf3f24.svg";
export { ForwardRef as ReactComponent };